export function updateFilterDefaultsWithPreservedState({ filterDefaults, previousStopsFilterState }) {
  const previousStopsFilterCheckedMap = new Map(
    previousStopsFilterState?.map((stop) => [stop.value, stop.checked])
  )
  filterDefaults?.NUM_OF_STOPS?.forEach((option) => {
    option.checked = previousStopsFilterCheckedMap.get(option.value) || false
    // Setting "disabled" to false allows user changes within the current slice,
    // In case no itineraries are found, user will see Adjust filter warning
    // This was necessary because stop filter selections would carry over to the next slice,
    // and the backend would set "disabled" to true for not selected stop filters for next slice call.
    option.disabled = false
  })
}
